import type { AppLang } from '@/lib/format'

// Keys MUST match the provider names the backend actually emits from
// `/api/payment/methods` — `services/payment/__init__.py::_PROVIDERS`
// plus the `pay_on_site` branch in `list_enabled_for_client()`. A name
// with no entry here falls through to the raw identifier, which the
// customer then sees verbatim at checkout.
const PAYMENT_LABELS = {
  telegram: { uk: 'Telegram Pay', en: 'Telegram Pay', ru: 'Telegram Pay' },
  liqpay: { uk: 'LiqPay', en: 'LiqPay', ru: 'LiqPay' },
  monopay: { uk: 'Monobank (Apple Pay / Картка)', en: 'Monobank (Apple Pay / Card)', ru: 'Monobank (Apple Pay / Карта)' },
  stripe: { uk: 'Stripe (Apple Pay / Картка / BLIK)', en: 'Stripe (Apple Pay / Card / BLIK)', ru: 'Stripe (Apple Pay / Карта / BLIK)' },
  sandbox: { uk: 'Тестова оплата (Sandbox)', en: 'Test Payment (Sandbox)', ru: 'Тестовая оплата (Sandbox)' },
  manual: { uk: 'Оплата за реквізитами (IBAN / Картка)', en: 'Bank transfer (IBAN / Card)', ru: 'Оплата по реквизитам (IBAN / Карта)' },
  cod: { uk: 'Післяплата (при отриманні)', en: 'Cash on delivery', ru: 'Наложенный платеж (при получении)' },
  pay_on_site: { uk: 'Оплата на місці', en: 'Pay on site', ru: 'Оплата на месте' },
  custom: { uk: 'Оплата за домовленістю з майстром', en: 'Arrangement with the master', ru: 'Оплата по договоренности с мастером' },
} as const

const KLODCHIK_MANUAL_LABEL = {
  uk: 'Оплата за домовленістю з майстром',
  en: 'Arrangement with the master',
  ru: 'Оплата по договоренности с мастером',
} as const

export function paymentLabel(method: string, lang: AppLang, isKlodchik?: boolean): string {
  if (isKlodchik && (method === 'manual' || method === 'custom')) {
    return KLODCHIK_MANUAL_LABEL[lang] ?? method
  }
  return PAYMENT_LABELS[method as keyof typeof PAYMENT_LABELS]?.[lang] ?? method
}

